/**
 * DevExtreme (ui/html_editor/quill_importer.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQuill = void 0;
var _ui = require("../widget/ui.errors");
var _ui2 = _interopRequireDefault(_ui);
var _window = require("../../core/utils/window");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    }
}
var Quill;

function getQuill() {
    if (!Quill) {
        Quill = requestQuill()
    }
    return Quill
}

function requestQuill() {
    var window = (0, _window.getWindow)();
    var quill = window && window.Quill || require("quill");
    if (!quill) {
        throw _ui2.default.Error("E1041", "Quill")
    }
    return quill
}
exports.getQuill = getQuill;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/html_editor/quill_importer.js
// module id = 78
// module chunks = 0